import { render, staticRenderFns } from "./CardUsuario.vue?vue&type=template&id=8fc57af8&scoped=true"
import script from "./CardUsuario.vue?vue&type=script&lang=ts"
export * from "./CardUsuario.vue?vue&type=script&lang=ts"
import style0 from "./CardUsuario.vue?vue&type=style&index=0&id=8fc57af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc57af8",
  null
  
)

export default component.exports